import { Descriptions, Tag } from "antd";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import EditAttachments from "../../../Helpers/Dropzone/EditAttachments";

export function GeneralTab({ data }) {
  const statusColors = {
    ACTIVE: `green`,
    INACTIVE: `red`,
  };

  if (!data) {
    return null;
  }

  const items = [
    {
      label: trans("Company Code"),
      children: data?.code || "-",
      span: 3,
    },
    {
      label: trans("Company Name"),
      children: data?.name || "-",
      span: 3,
    },
    {
      label: trans("Status"),
      span: 3,
      children: (
        <Tag
          color={statusColors[data.status] || statusColors.INACTIVE}
          className="text-capitalize"
        >
          {trans(data.status)}
        </Tag>
      ),
    },
    // {
    //   label: trans("Trade"),
    //   span: 3,
    //   children: Array.isArray(data?.trade)
    //     ? data.trade.join(", ")
    //     : data?.trade || "-",
    // },
    {
      label: trans("License Number"),
      children: data?.licenseNumber || "-",
      span: 3,
    },
    {
      label: trans("Contact Person"),
      children: data?.contactPerson || "-",
      span: 3,
    },
    {
      label: trans("Contact Email"),
      children: data?.contactEmail || "-",
      span: 3,
    },
    {
      label: trans("Contact Phone"),
      children: data?.contactPhone || "-",
      span: 3,
    },
    {
      label: trans("Address"),
      children: data?.address || "-",
      span: 6,
    },
    {
      label: trans("Created At"),
      children: data?.createdAt ? formatDateString(data.createdAt) : "-",
      span: 3,
    },
    {
      label: trans("Updated At"),
      children: data?.updatedAt ? formatDateString(data.updatedAt) : "-",
      span: 3,
    },
  ];

  return (
    <div style={{ padding: "16px 0" }}>
      <Descriptions
        title={trans("Company Information")}
        bordered
        column={6}
        items={items}
        size="small"
      />
      <div className="mt-1rem">
        {data?.attachments && data?.attachments.length > 0 && (
          <div className="mb-3">
            <label className="form-label">{trans("Attachments")}</label>
            <EditAttachments attachments={data?.attachments} viewOnly={true} />
          </div>
        )}
      </div>
    </div>
  );
}
